import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { EXPORT_LOGS_CSV } from "../types";
import { EXPORT_LOGS_CSV_MESSAGES } from "../constants/logMessages";

import { sendApiRequest, notifyError, notifyWarning } from "../../../actions";

import {
  exportLogsCsvFulfilled,
  exportLogsCsvPending,
  exportLogsCsvRejected,
} from "../actions";
import generateError from "../../../utilities/generateError";

const createPayload = (payload) => ({
  method: "get",
  url: "log/export",
  onSuccess: [
    (response) =>
      response.data.length === 0
        ? notifyWarning(EXPORT_LOGS_CSV_MESSAGES.NOT_FOUND)
        : exportLogsCsvFulfilled(response),
  ],
  onError: [
    exportLogsCsvRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "pdfApi",
};

const exportLogsCsvEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(EXPORT_LOGS_CSV.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) =>
      merge(
        of(exportLogsCsvPending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default exportLogsCsvEpic$;



// WEBPACK FOOTER //
// ./src/features/log/epics/exportLogsCsvEpic.js